/**
 * Kafelki mapy - paleta PlanGoNOW (rdzeń: #FEB139 → #FD7651 → #EA6820; rozszerzenie w brandzie).
 * Style: default | light | subtle | dark | monochrome - zsynchronizowane z useMapStyle.
 *
 * Źródła: Carto Basemaps (bezpłatne, bez klucza) + OSM jako „standard”.
 */

const OSM_ATTR =
  '&copy; <a href="https://www.openstreetmap.org/copyright" rel="noreferrer">OpenStreetMap</a>';

const CARTO_ATTR = '&copy; OpenStreetMap contributors &copy; CARTO';

/** Voyager - czytelne kolory, dobrze komponuje się z kolorowymi pinezkami wydarzeń */
const CARTO_VOYAGER =
  'https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png';

/** Positron - bardzo jasne tło, neutralne szarości */
const CARTO_POSITRON = 'https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png';

/** Ciemna baza z wyraźnym kontrastem */
const CARTO_DARK = 'https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png';

/** Minimalne etykiety - pod filtr „monochrom” */
const CARTO_POSITRON_NO_LABELS =
  'https://{s}.basemaps.cartocdn.com/light_nolabels/{z}/{x}/{y}{r}.png';

export function getTileLayerConfig(mapStyle) {
  switch (mapStyle) {
    case 'dark':
      return {
        url: CARTO_DARK,
        attribution: CARTO_ATTR,
        maxNativeZoom: 20,
      };
    case 'light':
      return {
        url: CARTO_POSITRON,
        attribution: CARTO_ATTR,
        maxNativeZoom: 20,
      };
    case 'subtle':
      return {
        url: CARTO_VOYAGER,
        attribution: CARTO_ATTR,
        maxNativeZoom: 20,
      };
    case 'monochrome':
      return {
        url: CARTO_POSITRON_NO_LABELS,
        attribution: CARTO_ATTR,
        maxNativeZoom: 20,
      };
    case 'default':
    default:
      return {
        url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
        attribution: OSM_ATTR,
        maxNativeZoom: 19,
      };
  }
}
